import styled from 'styled-components';
import {
  profileTagBase,
  ProfileIcon as BaseProfileIcon,
  ProfileIconUser as BaseProfileIconUser,
} from 'shiftNotes/styles/ProfileTag.style';

export const Link = styled.span`
  ${profileTagBase}

  &:hover {
    opacity: 0.8;
  }
`;

export const ProfileIcon = BaseProfileIcon;

export const ProfileIconUser = BaseProfileIconUser;
